import { render } from "./two-columns.html?vue&type=template&id=7f7c61aa"
import script from "./two-columns.js?vue&type=script&lang=js"
export * from "./two-columns.js?vue&type=script&lang=js"

import "./two-columns.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__